import { Box, SxProps, Theme, useTheme } from '@mui/material';

export interface OverlayContentProps {
  data: string | undefined;
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    container: {
      '.ql-align-center': {
        textAlign: 'center !important',
      },
      '.ql-align-left': {
        textAlign: 'left !important',
      },
      '.ql-align-right': {
        textAlign: 'right !important',
      },
      '.ql-align-justify': {
        textAlign: 'justify !important',
      },
    },
  };
};

export default function OverlayContent(props: OverlayContentProps) {
  const { data } = props;

  const theme = useTheme();
  const styles = getStyles(theme);
  return (
    <Box fontSize="2.4rem" sx={styles.container}>
      <div dangerouslySetInnerHTML={{ __html: data || '' }} />
    </Box>
  );
}
